import { render, staticRenderFns } from "./DoKoPig.vue?vue&type=template&id=6ec4059a&"
import script from "./DoKoPig.vue?vue&type=script&lang=ts&"
export * from "./DoKoPig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports